import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ArrowLeft } from "lucide-react";
import "./OnboardingTutorialSteps.css";
import MobileTopBar from "../../components/MobileTopBar";
import MobileBottomBar from "../../components/MobileBottomBar";
import DesktopTopBar from "../../components/DesktopTopBar";
import DesktopBottomBar from "../../components/DesktopBottomBar";
import nextGreenIcon from "../../assets/nextButtonIcon.png";
import nextBlueIcon from "../../assets/nextButtonIcon2.png";
import tutorial_1 from "../../assets/onboardingTute/tutorial_1.png";
import tutorial_2 from "../../assets/onboardingTute/tutorial_2.png";
import tutorial_3 from "../../assets/onboardingTute/tutorial_3.png";
import tutorial_4 from "../../assets/onboardingTute/tutorial_4.png";
import tutorial_5 from "../../assets/onboardingTute/tutorial_5.png";
import tutorial_6 from "../../assets/onboardingTute/tutorial_6.png";
import tutorial_6_pal from "../../assets/onboardingTute/tutorial_6_pal.png";
import tutorial_7 from "../../assets/onboardingTute/tutorial_7.png";
import tutorial_8 from "../../assets/onboardingTute/tutorial_8.png";
import tutorial_9 from "../../assets/onboardingTute/tutorial_9.png";
import tutorial_10 from "../../assets/onboardingTute/tutorial_10.png";

const pupParentOnboardingData = [
  {
    id: "main-1",
    theme: "teal",
    slides: [
      {
        image: tutorial_1,
        title: "Welcome, Pup Pawrent!",
        description: `You and your dog deserve a village!
Social Paws helps you build trusted relationships with nearby dog lovers so your pup can enjoy more walks, adventures, and companionship. 
We're excited to show you how it works!`,
      },
    ],
  },
  {
    id: "main-2",
    theme: "teal",
    slides: [
      {
        image: tutorial_2,
        title: "Sniff Around the Neighborhood",
        description: `Welcome to a very special community! 
Everyone on Social Paws believes neighbors can help one another by sharing the love of dogs. 
Browse nearby profiles in Map`,
      },
      {
        image: tutorial_3,
        title: "Browse in Map View",
        description: `Browse nearby profiles in Map View by tapping on the dog or human profile pic to learn more about each Pup or Pup Pal
Pup Pals display a 🤍 icon and Pups display a 🦴 icon`,
      },
      {
        image: tutorial_4,
        title: "Prefer to Scroll?",
        description: `Switch to List View and TAP to SPIN each profile card to meet the Pawrent behind the leash!`,
      },
      {
        image: tutorial_5,
        title: "Not Seeing Many Dogs?",
        description: `Make sure you've enabled your location, this is super important and does require a one-time effort! 
Most of our community is also currently based in Manhattan, NYC.`,
      },
    ],
  },
  {
    id: "main-3",
    theme: "teal",
    slides: [
      {
        image: tutorial_6,
        title: "Go In for a Sniff",
        description: `Found someone your pup might love to meet? 
Here's how to get the pawty started!`,
      },
      {
        image: tutorial_7,
        title: "Toss a Treat",
        description: `Tossing a Treat is the Social Paws way to "wag your tail" at a Pup or Pup Pal that you want to start a conversation or even offer a walk to!
The Pup Pawrent or Pup Pal will be notified and can "Toss a Treat" back.`,
      },
      {
        image: tutorial_8,
        title: "Send a Message",
        description: `Send A Message
Say Woof! Get the barking started: tell them a bit about you and your pup — just a few words can go a long way!`,
      },
      {
        image: tutorial_9,
        title: "Offer a Group Walk",
        description: `Invite them to your next walkie using our calendar or “I’m flexible feature!"
The Pup Pawrent or Pup Pal will be notified and can accept — or suggest another time or place — for the walk. 
Just like pups, every great dog-sharing journey begins with an invitation to play!`,
      },
    ],
  },
  {
    id: "main-4",
    theme: "blue",
    slides: [
      {
        image: tutorial_10,
        title: "Build Your Village",
        description: `As you build trust together, you'll progress through the Social Paws Milestones.
Before you know it, you'll have a village of Trusted Pup Pals who know, love, and care for your dog almost as much as you do!`,
      },
    ],
  },
];
const pupPalOnboardingData = [
  {
    id: "main-1",
    theme: "teal",
    slides: [
      {
        image: tutorial_1,
        title: "Welcome, Pup Pal!",
        description: `Love dogs? Don’t have one right now? You're in the right place! 
        Social Paws helps you connect with nearby pups while giving their Pawrents a helping hand. Together, we're building a community where neighbors get to SHARE the love of dogs. 
        We're excited to show you how!`,
      },
    ],
  },
  {
    id: "main-2",
    theme: "teal",
    slides: [
      {
        image: tutorial_2,
        title: "Sniff Around the Neighborhood",
        description: `Welcome to a very special community! 
        Everyone on Social Paws believes neighbors can help one another by sharing the love of dogs. 
        Browse adorable nearby pups in here in our Map View.`,
      },
      {
        image: tutorial_3,
        title: "Browse in Map View",
        description: `Browse nearby pups in Map View by tapping on a dog's profile to learn more about the Pup and the Pup Pawrent behind the leash.`,
      },
      {
        image: tutorial_4,
        title: "Prefer to Scroll?",
        description: `Switch to List View and flip each profile card to meet the Pawrent behind the Pup.`,
      },
      {
        image: tutorial_5,
        title: "Not Seeing Many Dogs?",
        description: `Make sure you've enabled your location, this is super important and does require a one-time effort! 
        Most of our community is also currently based in Manhattan, NYC.`,
      },
    ],
  },
  {
    id: "main-3",
    theme: "teal",
    slides: [
      {
        image: tutorial_6_pal,
        title: "Go In for a Sniff",
        description: `Found a pup that melts your heart? 
        Here's how to reach out and explore a connection!`,
      },
      {
        image: tutorial_7,
        title: "Toss a Treat",
        description: `Tossing a Treat is the Social Paws way to "wag your tail" at a Pup or Pup Pal that you want to start a conversation or even offer a walk!
The Pup Pawrent will be notified and can "Toss a Treat" back.`,
      },
      {
        image: tutorial_8,
        title: "Send a Message",
        description: `Say Woof! 
        Get the barking started: tell them a bit about you, your love for pups, and why you’d make the best Trusted Pup Pal to their furbaby — just a few words can go a long way!`,
      },
      {
        image: tutorial_9,
        title: "Offer a Group Walk",
        description: `Join their next walkie! 
        Use our calendar or “I’m flexible feature” to coordinate a time to walk altogether. 
        The Pup Pawrent will be notified and can accept — or suggest another time or place — for your walk. 
        Just like pups, every great dog-sharing journey begins with an invitation to play! `,
      },
    ],
  },
  {
    id: "main-4",
    theme: "blue",
    slides: [
      {
        image: tutorial_10,
        title: "Become Part of the Village",
        description: `As you build trust together, you'll progress through the Social Paws Milestone Journey. 
Before you know it, you will become a Trusted Pup Pal — the dog aunt or uncle to one (or many!) pups in your neighborhood. `,
      },
    ],
  },
];

const OnboardingTutorialSteps = ({ formData }) => {
  const navigate = useNavigate();

  // Fetch profile to check user dog status
  const profile = useSelector((state) => state.user.profile);

  // Determine which dataset to use based on the conditions
  const isPupPal =
    formData?.team === "social" || profile?.user_dog_status === 0;
  const activeDataList = isPupPal
    ? pupPalOnboardingData
    : pupParentOnboardingData;

  const [currentMainView, setCurrentMainView] = useState(0);
  const [currentSubViewIndex, setCurrentSubViewIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Refs for swipe detection
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const activeMainData = activeDataList[currentMainView];
  const activeSlide = activeMainData.slides[currentSubViewIndex];

  // Dynamically set variant and icon based on theme
  const bottomBarVariant = activeMainData.theme === "teal" ? "blue" : "green";
  const nextIcon =
    activeMainData.theme === "teal" ? nextBlueIcon : nextGreenIcon;

  // Reset loader when the slide changes
  useEffect(() => {
    setImageLoaded(false);
  }, [activeSlide.image]);

  const handleNextMainView = () => {
    if (currentMainView < activeDataList.length - 1) {
      setCurrentMainView(currentMainView + 1);
      setCurrentSubViewIndex(0);
    } else {
      navigate("/half-onboarding-page");
    }
  };

  const handleBackMainView = () => {
    if (currentMainView > 0) {
      setCurrentMainView(currentMainView - 1);
      setCurrentSubViewIndex(0);
    } else {
      navigate("/onboarding-tutorial");
    }
  };

  // Swipe gesture handlers
  const handleTouchStart = (e) => {
    touchStartX.current = e.targetTouches[0].clientX;
    touchEndX.current = 0;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.targetTouches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!touchEndX.current) return;

    const swipeDistance = touchStartX.current - touchEndX.current;
    const minSwipeDistance = 50;

    if (swipeDistance > minSwipeDistance) {
      // Swiped left to Next subview
      if (currentSubViewIndex < activeMainData.slides.length - 1) {
        setCurrentSubViewIndex((prev) => prev + 1);
      }
    } else if (swipeDistance < -minSwipeDistance) {
      // Swiped right to Previous subview
      if (currentSubViewIndex > 0) {
        setCurrentSubViewIndex((prev) => prev - 1);
      }
    }

    // Reset touch coordinates
    touchStartX.current = 0;
    touchEndX.current = 0;
  };

  return (
    <div className={`tutorial-container theme-${activeMainData.theme}`}>
      {/* Header */}
      <MobileTopBar
        showBackButton={true}
        onBack={handleBackMainView}
        backColor={activeMainData.theme === "teal" ? "#000" : "#fff"}
        logoColor={activeMainData.theme === "teal" ? "#009fd9" : "#fff"}
        blueLogo={activeMainData.theme === "teal"}
        isProtectedRoute={false}
      />
      <DesktopTopBar
        showBack={true}
        onBack={handleBackMainView}
        backColor={activeMainData.theme === "teal" ? "#000" : "#fff"}
        showProgress={false}
      />

      {/* Main Swipeable Area - Now Scrollable */}
      <div
        className="tutorial-swipe-area"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Single Wrapper for Image, Dots, and Description */}
        <div className="tutorial-content-wrapper">
          <div className="tutorial-image-wrapper">
            {/* Loader Spinner */}
            {!imageLoaded && (
              <div className="image-loader">
                <div className="spinner"></div>
              </div>
            )}

            <img
              src={activeSlide.image}
              alt={`Tutorial slide ${currentSubViewIndex + 1}`}
              className={`app-mockup-image fade-in ${imageLoaded ? "visible" : "hidden"}`}
              key={activeSlide.image}
              onLoad={() => setImageLoaded(true)}
            />
          </div>

          <div
            className="dot-indicators"
            style={{ opacity: activeMainData.slides.length > 1 ? 1 : 0 }}
          >
            {activeMainData.slides.map((_, index) => (
              <div
                key={index}
                className={`dot ${index === currentSubViewIndex ? "active" : ""}`}
                onClick={() => setCurrentSubViewIndex(index)}
              />
            ))}
          </div>

          <div className="info-card fade-in" key={activeSlide.title}>
            <h2 style={{ whiteSpace: "pre-line" }}>{activeSlide.title}</h2>
            <p style={{ whiteSpace: "pre-line" }}>{activeSlide.description}</p>
          </div>
        </div>
      </div>

      {/* Footer Next Button */}
      <DesktopBottomBar
        onNext={handleNextMainView}
        isNextEnabled={true}
        nextIconSrc={nextIcon}
        showSkip={false}
        variant={bottomBarVariant}
      />

      <MobileBottomBar
        onNext={handleNextMainView}
        isNextEnabled={true}
        nextIconSrc={nextIcon}
        showSkip={false}
        variant={bottomBarVariant}
      />
    </div>
  );
};

export default OnboardingTutorialSteps;
